import React, { Component } from "react"

import Screen from '../ui/Screen'

import ControlPanel from "./ShopScreen/ControlPanel"
import ShopList from "./ShopScreen/ShopList"

import ErrorMessageDialog from "../ui/ErrorMessageDialog.js"

import AddShopDialog from "./ShopScreen/AddShopDialog.js"
import EditShopDialog from "./ShopScreen/EditShopDialog.js"
import DeleteShopDialog from "./ShopScreen/DeleteShopDialog.js"

import api from "../api.js"

class ShopScreen extends Component {

	constructor(props) {
		
		super(props)

		this.state = {
			selected: undefined,
			dialog: undefined,
			screen: undefined,
			shops: [],
		}

		this.handle_error = this.handle_error.bind(this)
		this.handle_addShop = this.handle_addShop.bind(this)
		this.handle_editShop = this.handle_editShop.bind(this)
		this.handle_deleteShop = this.handle_deleteShop.bind(this)
		this.handle_clickShop = this.handle_clickShop.bind(this)

	}

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => {this.setState({dialog: undefined})})
						.catch(this.handle_error)
				}}
			/>
		})
	}	

	update = async () => api.shops.list().then(response => this.setState({shops: response.shops}))

	componentDidMount() {
		this.update().catch(this.handleError)
	}	

	handle_addShop() {
		this.setState({
			dialog: <AddShopDialog
				onAddShopClick = {(shop) => {
					api.shops.create(shop.name)
						.then(async response => {
							const resp = await api.shops.get(response.id)
							this.setState({selected: resp.shop})
						})
						.then(this.update)
						.then(() => { this.setState({dialog: undefined}) })
						.catch(this.handle_error)
				}}
				onCancelClick = {() => this.setState({dialog: undefined})}
			/>
		})
	}

	handle_editShop(shop) {
		this.setState({
			dialog: <EditShopDialog 
				shop = {shop}
				onEditShopClick = {(shop) => {
					api.shops.update(this.state.selected.id, shop.name)
						.then(this.update)
						.then(() => { this.setState({dialog: undefined, selected: this.state.shops.find(s => s.id == shop.id)}) })
						.catch(this.handle_error)
				}}
				onCancelClick = {() => {this.setState({dialog: undefined})}}
			/>
		})
	}

	handle_deleteShop(shop) {
		this.setState({
			dialog: <DeleteShopDialog
				shop = {shop}
				onDeleteShop = {(shop) => {
					api.shops.delete(shop.id)
						.then(this.update)
						.then(() => { this.setState({dialog: undefined, selected: undefined}) })
						.catch(this.handle_error)
				}}
				onCancel = {() => {this.setState({dialog: undefined})}}
			/>
		})
	}

	handle_clickShop(shop) {
		this.setState({selected: shop})
	}

	render() {

		if (this.state.screen) {
			return this.state.screen
		}

		return <Screen
			onClick = {e => {
				e.stopPropagation()
				if (!this.state.dialog) this.setState({selected: undefined})
			}}
		>

			{this.state.dialog}
			
			<ControlPanel
				selected = {this.state.selected}
				onAddShopClick = {this.handle_addShop}
				onEditShopClick = {this.handle_editShop}
				onDeleteShopClick = {this.handle_deleteShop}
			/>

			<ShopList
				shops = {this.state.shops}
				selected = {this.state.selected}
				onShopClick = {this.handle_clickShop}
				onShopDoubleClick = {shop => {
					this.setState({selected: shop}, () => {
						this.handle_editShop(this.state.selected)
					})
				}}
			/>

		</Screen>

	}    

}

export default ShopScreen